import React, { Component } from 'react';
import {observer} from "mobx-react"
import EntreeStore from "../EntreeStore"
import axios from "axios"
import UploadImagePC from "./UploadImagePC"
import { HashRouter as Router, Route, Link } from "react-router-dom";
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';

// import Camera from 'react-html5-camera-photo';
import ShowImage from "./showImage"
@observer
class Takepicture extends React.Component {
  constructor(props) {
    super(props);
    this.onTakePhoto = this.onTakePhoto.bind(this)
    this.loadImages = this.loadImages.bind(this)

    this.state = {
      piece_id: this.props.match.params.pieceid,
      imagesData: [],
      images: []
    };
    EntreeStore.loadPieces()
    this.loadImages()
  }
  loadImages(){
    axios.post("/api/v1/experts/app/entree/dashboard/loadImages",{id: EntreeStore.rdv.id,expertiseid: this.props.match.params.expertiseid,piece: this.props.match.params.pieceid}).then((data)=>{
      this.setState({images: data.data})
    })
  }
  onTakePhoto (dataUri) {
    this.setState({imagesData: [...this.state.imagesData,dataUri]})
    axios.post("/api/v1/experts/app/entree/dashboard/uploadImageBase64",{
      expertiseid: this.props.match.params.expertiseid,
      data: dataUri,id: EntreeStore.rdv.id,
      piece: this.props.match.params.pieceid}).then((data)=>{
      this.loadImages()
    })
    console.log('takePhoto');
  }
  render() {
    if(EntreeStore.loaded){

      return(
        <div>

        <div className="row">
          <Link className="btn col s2 offset-s1" to={"/expertise/piece/"+this.props.match.params.pieceid+"/backward"} ><i className="material-icons left">keyboard_backspace</i>Canvas</Link>
          {/*<Link className="btn col s2 offset-s1" to={"/expertise/audio/"+this.props.match.params.pieceid+"/"+this.props.match.params.expertiseid} ><i className="material-icons left">record_voice_over</i>Audios</Link>*/}

          </div>
        <div className ="row">
        <div className="col s2">
          <ul>
            {this.state.images.map((img)=>(
                <li key={img.id}><ShowImage img={img} rdvid={EntreeStore.rdv.id} expertiseid={this.props.match.params.expertiseid} /></li>
              ))}

          </ul>
        </div>
        <div className="col s10">
        {EntreeStore.modepc ? (
          <div>
            <h1 className="center">Uploader une ou plusieurs photos</h1>
            <UploadImagePC
            id={EntreeStore.rdv.id}
            expertise={this.props.match.params.expertiseid}
            piece={this.props.match.params.pieceid}
            reload={this.loadImages}
            />
          </div>
          ) : (
        <Camera
            onTakePhoto = { (dataUri) => { this.onTakePhoto(dataUri); } }
            idealFacingMode = {FACING_MODES.ENVIRONMENT}

            />
          )}
        </div>
        </div>
        </div>
        )
    }else{
     return (
        <div>
        Chargement en cours
        </div>
      );
   }
  }
}



export default Takepicture
